import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useAppContext } from "@/components/AppContext";
import withDefaultLayout from "@/hoc/WithDefaultLayout";

import ConfigEditorDetailScreen from "./ConfigEditor/Detail";
import ConfigEditorScreen from "./ConfigEditor/ConfigEditorScreen";

const useUserEmail = (): string => {
  const { monetisationRoles, userProfile } = useAppContext();
  return monetisationRoles?.email ?? userProfile?.email ?? "";
};

const ConfigEditorRouteView: React.FC = () => {
  const userEmail = useUserEmail();
  const navigate = useNavigate();
  return (
    <ConfigEditorScreen
      userEmail={userEmail}
      onOpenFile={(folderId, fileId) => navigate(`/feeds/panchangam-config/${folderId}/${encodeURIComponent(fileId)}`)}
    />
  );
};

const ConfigEditorDetailRouteView: React.FC = () => {
  const userEmail = useUserEmail();
  const navigate = useNavigate();
  const { folderId, fileId } = useParams<{ folderId: string; fileId: string }>();

  if (!folderId || !fileId) {
    return null;
  }

  return (
    <ConfigEditorDetailScreen
      userEmail={userEmail}
      folderId={folderId}
      fileId={decodeURIComponent(fileId)}
      onBack={() => navigate("/feeds/panchangam-config")}
    />
  );
};

export const ConfigEditorRoute = withDefaultLayout(ConfigEditorRouteView);
export const ConfigEditorDetailRoute = withDefaultLayout(ConfigEditorDetailRouteView);

export default ConfigEditorRoute;
